import identificationValidation from "../commonValidationSchema/identificationValidation";
import residentialDetailsValidation from "../commonValidationSchema/residentialDetailsValidation";
import uploadChangeDocumentsValidation from "../commonValidationSchema/uploadChangeDocumentsValidation";
import uploadDocumentsValidation from "../commonValidationSchema/uploadDocumentsValidation";

/**
 * This returns an object composed of conditional `yup` schema,
 * based on the current tab of `Director` and `Authorized Person` officials.
 *
 * @param {string} selectedTab The current tab/step of the multi step form e.g `"generalInformation"`.
 * @param {string} idType The idType of the current official e.g `"Kenyan Citizen"`.
 * @param {string} isNonResident Conditional string value `'No' || 'Yes` of the current official.
 * @param {array} documentData The array of objects related to file uploads.
 * @return {object} This returns object containing schema.
 * @example
 *  {
 *    schema // yup schema
 *  }
 */

let ManageModuleChangeDocumentsData = [
  {
    documentsAreSigned: "true",
    fileMustUpload: true, // For signed documents, file upload is always required
  },
  {
    documentsAreSigned: "false",
    selectResolutionType: "ownResolutionType",
    fileMustUpload: true, // For documents not yet signed with own resolution type selected, file upload is required
  },
  {
    documentsAreSigned: "false",
    selectResolutionType: "platformResolutionType",
    fileMustUpload: false, // For documents not yet signed with platform resolution type selected, file upload is not required
  },
];
const getValidationSchema = ({
  selectedTab,
  idType,
  isNonResident = null,
  documentData,
  officialType = "",
  processType = "",
  actionType = "",
}) => {
  if (!selectedTab?.id)
    return identificationValidation(idType)
      .schema.concat(
        residentialDetailsValidation({ idType, isNonResident }).schema
      )
      .concat(uploadDocumentsValidation(documentData).schema);

  switch (selectedTab.id) {
    case "generalInformation":
      return identificationValidation(
        idType,
        processType,
        actionType,
        officialType
      );
    case "residentialDetails":
      return residentialDetailsValidation({ idType, isNonResident });
    case "uploadDocuments":
      return uploadDocumentsValidation(documentData);
    case "uploadChangeDocuments":
      return uploadChangeDocumentsValidation(
        processType === "Authorized Person"
          ? ManageModuleChangeDocumentsData
          : documentData
      );
    default:
      return { schema: null };
  }
};

export default getValidationSchema;
